/* eslint-disable react/jsx-props-no-spreading */
import { PaginationItem } from "@material-ui/lab";
import MuiPagination from "@material-ui/lab/Pagination";
import { ThemeProvider, makeStyles } from "@material-ui/styles";
import styled from "styled-components";
import Link from "next/link";
import theme from "../../styles/theme";

const useStyles = makeStyles({
	ul: {
		flexWrap: "wrap",
	},
});

export type PaginationPropsType = {
	handlePageChange?: (event) => void;
	totalPages: number;
	currentPage: number;
	routerBased?: boolean;
	baseUrl?: string;
};

const Pagination: React.FC<PaginationPropsType> = ({
	handlePageChange,
	totalPages,
	currentPage,
	routerBased = false,
	baseUrl = "",
}) => {
	const classes = useStyles();

	if (!routerBased) {
		return (
			<ThemeProvider theme={theme}>
				<MuiPagination
					classes={{ ul: classes.ul }}
					color="primary"
					shape="rounded"
					defaultPage={1}
					count={totalPages}
					page={currentPage}
					onChange={handlePageChange}
					siblingCount={0}
					boundaryCount={1}
				/>
			</ThemeProvider>
		);
	}

	return (
		<ThemeProvider theme={theme}>
			<MuiPagination
				classes={{ ul: classes.ul }}
				color="primary"
				shape="rounded"
				count={totalPages}
				siblingCount={0}
				boundaryCount={1}
				page={currentPage}
				hideNextButton={currentPage === totalPages}
				hidePrevButton={currentPage === 1}
				renderItem={(item) => (
					<Link
						href={item.page === 1 ? baseUrl : `${baseUrl}?page=${item.page}`}
						passHref
					>
						<PaginationItem component={AnchorLinkComponent} {...item} />
					</Link>
				)}
			/>
		</ThemeProvider>
	);
};

const AnchorLinkComponent = styled.a`
	text-decoration: none;
`;

export default Pagination;
